import cx from 'classnames'
import { useCallback, useEffect, useState } from 'react'

export function Input ({ id, onChange, name, value, placeholder, errorMessage, type = 'text', onBlur, onFocus, rule, ...rest }) {
  const [ focused, setFocused ] = useState(false)
  const [ error, setError ] = useState(false)
  const [ accept, setAccept ] = useState(false)

  useEffect(() => {
    if (value?.length > 0) {
      setFocused(true)
    }
  }, [ value ])

  const validateValue = useCallback(value => {
    if (rule) {
      try {
        if (value.match(rule)) {
          setAccept(true)
          setError(false)
        } else {
          setError(true)
          setAccept(false)
        }
      } catch (e) {
        console.error(e)
      }
      return
    }

    if (value.length > 0) {
      setAccept(true)
      setError(false)
    } else {
      setError(true)
      setAccept(false)
    }
  }, [ rule ])

  const handleBlur = useCallback(() => {
    if (value?.length === 0 || !value) {
      setFocused(false)
    }

    validateValue(value)

    onBlur?.()
  }, [ onBlur, validateValue, value ])

  const handleFocus = useCallback(() => {
    setFocused(true)
    onFocus?.()
  }, [ onFocus ])

  const handleChange = useCallback(event => {
    if ((error || accept) || event.target.value.length - value.length > 1) {
      validateValue(event.target.value)
    }

    onChange(name, event.target.value)
  }, [ accept, error, name, onChange, validateValue, value.length ])

  return (
    <>
      <div className='login-input-wrapper'>
        <label
          htmlFor={id}
          className={cx('login-input-label', {
            focused
          })}
        >
          {placeholder}
        </label>
        <input
          id={id}
          className={cx('login-input', {
            error,
            accept
          })}
          type={type}
          required
          value={value}
          onChange={handleChange}
          onFocus={handleFocus}
          onBlur={handleBlur}
          {...rest}
        />
      </div>
      <p className='login-input-error'>{error ? errorMessage : ''}</p>
    </>
  )
}
